<template>
	<div class="layer-view" :class="{open}">
		<div @click="open=!open" class="opener">
			<current-track :trackId="trackId" />
			<p class="find" v-if="!open">
				Hitta i kartan
				<font-awesome-icon :icon="['fas', 'caret-down']" style="margin-left:8px;" />
			</p>
		</div>
		<div class="inner" v-if="open">
			<ul>
				<template v-for="layerGroup in layerGroups" v-if="getMarkers(layerGroup).length > 0">
					<li  :key="layerGroup.name" class="group">
						<span>{{layerGroup.name}}</span>
					</li>
					<li v-for="marker in getMarkers(layerGroup)" :key="marker.id" @click="markerClicked(marker)" class="normal">
						<marker-view :cat="marker.properties.cat" :anchor="marker.properties.anchor" :passed="true" text="5" :arrow="true" />
						<span>{{marker.properties.shortDesc || marker.properties.desc}}</span>
					</li>
				</template>
			</ul>
		</div>
		<div v-if="open" @click="open=false" class="closer">
			<font-awesome-icon :icon="['fas', 'caret-up']" />
		</div>
	</div>
</template>

<script>

import Vue from "vue"
import MarkerView from "./MarkerView.vue"
import CurrentTrack from "./CurrentTrack.vue";


export default Vue.extend({

	components: {
		MarkerView,
		CurrentTrack,
	},

	data() {
		return {
			open: false,
		}
	},

	props: {
		layerGroups: {
			type:Array,
			required: true,
		},
		markers: {
			type:Array,
			required: true,
		},
		trackId: {
			type: String,
			required: true,
		}


	},

	computed: {
		// visibleLayers() {
		// 	return this.layers.filter(layer => layer.visibleLayer != false)
		// }
	},

	methods: {
		getMarkers(group) {
			let m = this.markers.filter(marker => {
				return group.cats.includes(marker.properties.cat)
					&& (!marker.properties.tracks || marker.properties.tracks.includes(this.trackId))
			});
			m = m.sort((a, b) => a.properties.progress + (a.properties.order || 0) < b.properties.progress + (b.properties.order || 0) ? -1 : 1)
			return m;
		},

		markerClicked(marker) {
			this.$emit("markerClicked", marker)
			//layer.visible = !layer.visible;
		}
	},

	mounted() {
		this.open = window.innerWidth > 900;
	}

})

</script>

<style scoped>
	.layer-view {
		position: absolute;
		top: 10px;
		left: 10px;
		z-index: 100000001;
		padding: 5px 5px 5px 5px;
		border: solid 1px #ffffff00;
		border-radius: 8px;
		background-color: #ffffff66;
		max-height: calc(100vh - 170px);
		overflow: hidden;
		display: flex;
		flex-flow: column nowrap;
	}

	.layer-view.open {
		background-color: #FFFFFFbb;
		border: solid 1px #00000044;
	
	}

	.layer-view .inner {
		height: 100%;
		overflow-y: auto;

	}

	.layer-view .marker {
		/* display: inline-block; */
		transform: scale(.8);
		transform-origin: center !important;
	}

	.hidden {
		opacity: .5;
	}

	ul {
		list-style-type: none;
		padding: 0;
		margin: 0;
	}

	li {
		/* font-weight: bold; */
		font-size: .8em;
		/* margin-bottom: -.2em; */
		display: flex;
		align-items: center;
		padding-left: 4px;
	}

	li.normal {
		cursor: pointer;
	}

	li.group:not(:first-child) {
		margin-top: 8px;
	}

	li.group {
		font-weight: bold;
		margin-bottom: 4px;
		margin-right: 5px;
		font-size: 1em;
	}

	.opener {
		cursor: pointer;
	}

	.opener:hover .find {
		color: #555;

	}

	.find {
		cursor: pointer;
		display: inline;
		margin: 0;
		padding: 2px 4px;
		margin-left: 6px;
	}

	.find:hover {
	}

	.closer {
		cursor: pointer;
		line-height: 12px;
		background-color: #444;
		color: white;
		text-align: center;

		margin-top: 8px;
		margin-left: -5px;
		margin-right: -5px;
		margin-bottom: -5px;
		border-bottom-left-radius: 7px;
		border-bottom-right-radius: 7px;
	}

</style>